import api from '../../../App/socket';

export const deleteLeadProfilePhotos = (id, photos, photo_index) => api.send({
    api: 'module',
    module: 'Leads',
    classMethod: 'DeleteLeadPhoto',
    options: {
        update: {
            photo_index,
        },
        where: {
            _id: id,
        },
    },

}).then((response) => {
    return response;
}).catch((error) => {
    return error;
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/delete_lead_profile_photos_request.js